export default {
	userBasedPricingDescription: "Subscribe to User-based pricing",
	userBasedPricingAmount: "$7.00",
	userBasedPricingFrequency: "per month",
	userBasedPricingAltDescription: "User-based pricing",
	userBasedOrderSummary: "Qty 1, Billed monthly",
	totalPaidToday: "Total paid today",
	thankYou: "Thanks for subscribing",
	paymentOnStatement: "A payment to Stripe will appear on your statement",
	backToTeaming: "Let's get back to it!",
};
